<template>
  <div class="container">
    <common-title titleName="" />
    <div class="box">
      <img :src="url" class="img" alt="成功">
      <div class="text">信息已提交成功，将尽快为您发货</div>
      <div class="btn" @click="goback">查看信息</div>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';

export default {
  data() {
    return {
      url: `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BB%84_325%402x.png`,
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
  components: {
    CommonTitle,
  },
};
</script>
<style lang="scss" scoped>
  .container {
    padding-top: 351px;

    .box {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .img {
      width: 159px;
      height: 159px;
    }

    .text {
      font-size: 25px;
      color: #333333;
      margin: 36px 0 58px 0;
    }

    .btn {
      width: 225px;
      height: 58px;
      background: #FE7F41;
      border-radius: 29px;
      font-size: 25px;
      color: #FFFFFF;
      text-align: center;
      line-height: 58px;
    }
  }
</style>
